import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/buttons';
import { Locale } from '@/helpers/languages';
import { Modals } from '@/helpers/modals';
import { useGetCommonStore, useModalsStore } from '@/store';

import { ScAuthButton } from './styled';

export const AuthButtons = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const open = useModalsStore.use.open();

  const useCommonStore = useGetCommonStore();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const handleRegisterClick = () => {
    open(Modals.Registration);
  };

  const handleLoginClick = () => {
    open(Modals.Login);
  };

  const btnProps = useMemo(() => {
    const paddingX = [
      Locale.GERMAN,
      Locale.FRENCH_CANADA,
      Locale.FRENCH_SWITZERLAND,
    ].includes(language as Locale)
      ? 8
      : 16;
    return isMobileDevice ? { paddingX } : {};
  }, [isMobileDevice, language]);

  return (
    <>
      <ScAuthButton>
        <Button
          id="loginButton"
          large={!isMobileDevice}
          onClick={handleLoginClick}
          secondary
          small={isMobileDevice}
          testId="login-button"
          wide
          {...btnProps}
        >
          {t('button.login')}
        </Button>
      </ScAuthButton>
      <ScAuthButton>
        <Button
          id="registerButton"
          large={!isMobileDevice}
          onClick={handleRegisterClick}
          primary
          small={isMobileDevice}
          testId="register-button"
          wide
          {...btnProps}
        >
          {t('button.signUp')}
        </Button>
      </ScAuthButton>
    </>
  );
};
